import React from 'react';
import LoginButton from './LoginButton';
import {SearchWebUtils} from '@aperza/aperza-react-ui';

export default class UserMenu extends React.Component {
    constructor(props) {
        super(props);

    }
    componentDidMount() {

    }
    render() {

      //For Preview
      //https://aperza.atlassian.net/browse/AB-2505
      //https://aperza.atlassian.net/browse/AB-2533
      if (SearchWebUtils.getDisabledLinks()) {
        return <LoginButton actionUrl="#" />
      }

      const badgeComponent = (this.props.state.unreadCount > 0) ? (<span className={`badge-strong badge`}>{this.props.state.unreadCount}</span>) : null;
      const envBalloon = (env_locale_balloon !== null) ? (
          <span className={`envBalloon ${env_locale_balloon}`}>{env_locale_balloon}</span>
        ) : null;


        if( serviceType !== "am-news" ) {

            //通信していないとき
            if(this.props.state.isValid == false){
                return (
                    <a href="/" className="header_userNoLogin header_menuLoading"><img src={`${cdn_base_domain}/common/images/img_loading.svg`} alt="loading" width="25" height="25" className="loadImg" /></a>
                );
            }
            if (!this.props.state.user.valid) {
                if( typeof encodedPath !== "undefined"){
                    return <LoginButton actionUrl={`https://id${base_domain}/login/${serviceType}/?rp=header&path=${encodedPath}`} />
                    //return <a data-tracking-action="usermenu_login" href={`https://id${base_domain}/login/${serviceType}/?rp=header&path=${encodedPath}`} className="td_aperza_component_usermenu header_userNoLogin"><img src="//static.aperza.jp/common/images/img_userLogin.svg"/></a>
                }else{
                    return <LoginButton actionUrl={`https://id${base_domain}/login/${serviceType}/?rp=header`} />
                    //return <a data-tracking-action="usermenu_login" href={`https://id${base_domain}/login/${serviceType}/?rp=header`} className="header_userNoLogin td_aperza_component_usermenu"><img src="//static.aperza.jp/common/images/img_userLogin.svg"/></a>
                }
            } else { //メニューが出る時
                let site = "";
                if( serviceType === "news-aperza" || serviceType === "search-aperza"){
                    site =  serviceType + "/";
                } else if ( serviceType === "aperza-biz" ) {
                    site = "aperza-biz/?path=/index.html";
                } else if ( serviceType === "order-aperza" ) {
                    site = `https://www${base_domain}`;
                }

                let BizMenu = (this.props.state.isBusiness) ?
                    (
                        <dd>
                            <a
                                data-tracking-action="usermenu_biz"
                                target="_blank"
                                href={`https://business${base_com_domain}/dashboard/`}
                            >
                                購買アカウント
                                <div className="caption-s">
                                    Aperzaでの購買履歴確認などが行えます
                                </div>
                            </a>
                        </dd>
                    ) : null ;

                return (
                    <div className="reactroot">
                        {envBalloon}
                        <a href={`https://account${base_domain}/`}><img src={this.props.state.user.photoUrl} className="userIcon userIcon-s" key="1"/></a>
                        {badgeComponent}
                        <div className="header_userMenu is-close" key="2">
                            <dl>
                                <dt><a  data-tracking-action="usermenu_mytop" href={`https://account${base_domain}/`}>{`${this.props.state.user.displayName}さん`}</a></dt>
                                <dd><a data-tracking-action="usermenu_clip"  href={`https://account${base_domain}/clip`}>クリップ一覧<div className="caption-s">クリップ済コンテンツ一覧</div></a></dd>
                                <dd><a data-tracking-action="usermenu_history" href={`https://account${base_domain}/history`}>ダウンロード履歴<div className="caption-s">ダウンロード済みファイル一覧</div></a></dd>
                                <dd><a data-tracking-action="usermenu_mail" href={`https://account${base_domain}/mail`}>メールマガジン設定<div className="caption-s">各種メールマガジンの受信設定</div></a></dd>
                                <dd><a  data-tracking-action="usermenu_account" href={`https://account${base_domain}/account`}>アカウントサービス<div className="caption-s">個人設定</div></a></dd>
                                <dd><a  data-tracking-action="usermenu_message" target="_blank" href={`https://${base_cluez_member_domain}/ja/message/list`}>メッセージ<div className="caption-s">企業とのメッセージ一覧に移動します</div></a></dd>
                                { BizMenu }
                                <dd  data-tracking-action="usermenu_logout" className="header_userMenu-logout"><a href={`https://id${base_domain}/logout/${site}?path=${ document.domain.match(/order/) ? "" : encodedPath}`}>ログアウト</a></dd>
                            </dl>
                        </div>
                    </div>

                );
            }
        }else{
            //通信していないとき
            if(this.props.state.isValid == false){
                return (
                    <a href="/" className="header_userNoLogin header_menuLoading"><img src={`${cdn_base_domain}/common/images/img_loading.svg`} alt="loading" width="10" height="10" className="loadImg" /></a>
                );
            }
            if (!this.props.state.user.valid) {
                if( typeof encodedPath !== "undefined"){
                    return <a href={`https://id${base_domain}/login/${serviceType}/?rp=header&path=${encodedPath}`}>ログイン</a>
                }else {
                    return <a href={`https://id${base_domain}/login/${serviceType}/?rp=header`}>ログイン</a>
                }
            } else {
                return <a href={`https://account${base_domain}`} target="_blank">{this.props.state.user.displayName}さんのMyページ</a>
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/UserMenu.js